import React from 'react';
import ContentLoader from 'react-content-loader';

const JobLoading = () => (
	<ContentLoader
		height={135}
		width={900}
		speed={2}
		primaryColor='#f3f3f3'
		secondaryColor='#ecebeb'
	>
		<rect x='8' y='6' rx='0' ry='0' width='4' height='119' />
		<rect x='817' y='6' rx='0' ry='0' width='5' height='117' />
		<rect x='8' y='6' rx='0' ry='0' width='814' height='4' />
		<rect x='8' y='93' rx='0' ry='0' width='814' height='35' />
		<rect x='27' y='20' rx='0' ry='0' width='260' height='22' />
		<rect x='408' y='20' rx='0' ry='0' width='96' height='23' />
		<rect x='628' y='20' rx='0' ry='0' width='96' height='22' />
		<rect x='26' y='59' rx='0' ry='0' width='260' height='12' />
		<rect x='310' y='206' rx='0' ry='0' width='0' height='0' />
		<rect x='106' y='364' rx='0' ry='0' width='0' height='0' />
	</ContentLoader>
);

export default JobLoading;
